<template>
  <button class="btn" @click="open_dialog">Tạo yêu cầu quét</button>
  <dialog id="confirm_create_scan_open_port" class="modal">
    <div class="modal-box">
      <h3 class="mb-4 text-lg font-bold">Xác nhận quét</h3>

      <div class="modal-action">
        <form method="dialog" class="flex gap-2">
          <button class="btn" value="cancel">Hủy</button>
          <button class="btn btn-primary min-w-28" @click="handle_confirm">
            <span v-if="action_store.loading.create_action">
              <Loading />
            </span>
            <span v-else> Xác nhận </span>
          </button>
        </form>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import Loading from "@/components/LoadingTemplate.vue";
import { toast } from "vue3-toastify";
import { use_action } from "../ExplorerV2/useAction";

const action_store = use_action();

const open_dialog = () => {
  const dialog = document.getElementById(
    "confirm_create_scan_open_port",
  ) as HTMLDialogElement;
  dialog.showModal();
};

const handle_confirm = async () => {
  try {
    const action_id = await action_store.create_action({
      type: "open_port",
      action: "scan",
    });
    const dialog = document.getElementById(
      "confirm_create_scan_open_port",
    ) as HTMLDialogElement;
    dialog.close();
    toast.success("Yêu cầu quét cổng mở đã được tạo.");

    if (!action_id) {
      return;
    }
    action_store.watch_for_action(action_id, {
      on_complete: async () => {
        toast.success("Quét cổng mở hoàn tất.");
        action_store.get_action_history({
          type: "open_port",
          action: "scan",
        });
      },
    });
  } catch (error) {
    console.error(error);
    toast.error("Đã xảy ra lỗi khi tạo yêu cầu quét.");
  }
};
</script>
